export const USER_CREATE_RESET = "USER_CREATE_RESET";
export const USER_CREATE_SET_CREATED = "USER_CREATE_SET_CREATED";
export const USER_CREATE_SET_ERROR = "USER_CREATE_SET_ERROR";
export const USER_CREATE_SET_VIOLATIONS = "USER_CREATE_SET_VIOLATIONS";
export const USER_CREATE_TOGGLE_LOADING = "USER_CREATE_TOGGLE_LOADING";
